import { axiosApi } from '../../../app/api/api';
import {
  EditProfileAvatarData,
  EditProfileData,
  ProfileData,
} from 'entities/profile/model/userModel';

export const profileApi = {
  getMe: async () => {
    const res = await axiosApi.get<ProfileData>('/profiles/me');

    return res.data;
  },

  updateMe: async (data: EditProfileData) => {
    const res = await axiosApi.put<
      ProfileData & { token?: { access_token: string } }
    >('/profiles/me', { ...data, email: data.email.toLowerCase() });

    return res.data;
  },

  updateMeAvatar: async (data: EditProfileAvatarData) => {
    const fd = new FormData();

    if (data.avatar) {
      fd.append('avatar', data.avatar);
    }
    const res = await axiosApi.put<ProfileData>('/profiles/avatar', fd);

    return res.data;
  },

  deleteMeAvatar: async () => {
    await axiosApi.delete('/profiles/avatar');

    return true;
  },

  resetPassword: async (old_password: string, new_password: string) => {
    await axiosApi.post(
      '/profiles/reset_password',
      {},
      { params: { old_password, new_password } }
    );

    return true;
  },
};
